
import { catalogoObras } from "../../models/Colecciones.model";
import Elemento from "../../utilities/ListadoGenerico/elemento";
import Loading from "../../utilities/Loading";
import Listado from "./listado";

export default function ResultadosBusqueda(props: propsResultadosBusqueda) {
    const indice = (i:number)=>{ 
        let estilo = ''
        switch (i) {
            case 0:
                estilo = ''
            break;
            case 1:
            case 2:
                estilo = 'mt-3 mt-sm-0'
            break;
            default:
                estilo = 'mt-3 mt-lg-0'
            }
        return estilo 
     }
    if(!props.peticion){
        return <Loading/>
    } else if(props.resultados.length === undefined){
        return (<div className="container-fluid"><div className="row justify-content-start justify-content-lg-center text-start text-primary h4 mt-4">No se encontró información asociada al criterio definido.</div><br/></div>)
    }else{
        if(props.resultados.length === 0){
            return (<div className="container-fluid"><div className="row justify-content-start justify-content-lg-center text-start text-primary h4 mt-4">No se encontró información asociada al criterio definido.</div><br/></div>)
        }else{
            return(
                <div className="container-fluid">
                    <div className="row justify-content-start justify-content-lg-center text-start">
                    {  (props.tipo===1) &&          
                        props.resultados.map( (obra, i) =>{                        
                        return <Elemento valida_clase={ indice(i)} id={obra.id} imagen={obra.imagen} descripcion={obra.descripcion} anio={obra.anio} key={i}/>                      
                        })
                    }
                    {  (props.tipo===2) && <Listado lista={props.resultados} pag={props.pag}/> }
                    </div>
                </div> 
            );
        }
    }   
}

interface propsResultadosBusqueda{
    resultados: catalogoObras[];
    tipo:number;
    peticion:boolean;
    pag:number;
}


